import { render } from "./TicketList.vue?vue&type=template&id=0937f4fc&scoped=true"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import "./TicketList.vue?vue&type=style&index=0&id=0937f4fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src739691156/src/fellow/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0937f4fc"]])

export default __exports__